// extracted by mini-css-extract-plugin
module.exports =  {"ModalSocialButton":"v7lk_cyHqkKccFkZpVIQ","ModalSocialButton__Save":"sX2GY9SjBQHNuEM1E5bQ","ModalSocialButton__Message":"lgKxz3CfwOuTYvcbgmYn"};